module.exports = __webpack_public_path__ + "static/checkout-with-billsbot-28422e6a3515e2f85720e836a7ef793f.svg";